import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { transitionSteps, transitionStepsAsync } from '../lib/step_transition';
import { getCsrfToken } from '../lib/csrf';

export default class extends Controller {
  static targets = [
    'amountInput',
    'step1',
    'step2',
    'cardOption',
    'cardAmountField',
    'loadingStep',
    'wireStep',
    'amountDisplay',
  ];

  static values = {
    maxCardAmount: { type: Number, default: 1500 },
    hasViban: { type: Boolean, default: false },
    generateVibanUrl: String,
  };

  disconnect() {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }
  }

  selectPreset(event) {
    const amount = event.currentTarget.dataset.amount;
    this.amountInputTarget.value = amount;
  }

  goToStep2() {
    const amount = parseInt(this.amountInputTarget.value, 10);
    if (!amount || amount < 1) return;

    this.amountDisplayTargets.forEach(el => {
      el.textContent = `${amount} €`;
    });
    this.cardAmountFieldTarget.value = amount;

    if (amount > this.maxCardAmountValue) {
      this.cardOptionTarget.classList.add('d-none');
    } else {
      this.cardOptionTarget.classList.remove('d-none');
    }

    this.#transition(this.step1Target, this.step2Target, 'forward');
  }

  goBack() {
    this.#transition(this.step2Target, this.step1Target, 'backward');
  }

  selectCard() {
    this.cardAmountFieldTarget.form.requestSubmit();
  }

  async selectWire() {
    if (this.hasVibanValue) {
      this.#transition(this.step2Target, this.wireStepTarget, 'forward');
      return;
    }

    await transitionStepsAsync(this.step2Target, this.loadingStepTarget, 'forward');

    try {
      const amount = this.amountInputTarget.value;
      const url = new URL(this.generateVibanUrlValue, window.location.origin);
      if (amount) url.searchParams.set('amount', amount);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': getCsrfToken(),
        },
        credentials: 'same-origin',
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
        this.hasVibanValue = true;
      } else {
        this.#transition(this.loadingStepTarget, this.step2Target, 'backward');
        return;
      }
    } catch {
      this.#transition(this.loadingStepTarget, this.step2Target, 'backward');
      return;
    }

    this.#transition(this.loadingStepTarget, this.wireStepTarget, 'forward');
  }

  backToStep2() {
    this.#transition(this.wireStepTarget, this.step2Target, 'backward');
  }

  #transition(outEl, inEl, direction) {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
    }
    this.pendingTimeout = transitionSteps(outEl, inEl, direction);
  }

}
